import {useMemo, useCallback} from 'react'

import {noop} from '../../../../utils/empty'
import type {RunnerType} from '../SelectBuildRunners.types'

type UseSelectBuildRunnersItemProps = {
  runner: RunnerType
  onSelect: () => void
  onLoadingComplete: () => void
}

type UseSelectBuildRunnersItem = {
  title: {
    deprecated: boolean
    name: string
  }
  key: string
  dataTestId: string
  runnerDescription: string
  runnerIconUrl: string
  handlerSelectBuildRunnersItemClick: () => void
}

function useSelectBuildRunnersItem({
  runner,
  onSelect,
  onLoadingComplete = noop,
}: UseSelectBuildRunnersItemProps): UseSelectBuildRunnersItem {
  const runnerIconUrl = runner?.iconUrl ? `${window.base_uri}${runner?.iconUrl}` : ''
  const dataTestId = `runner-item ${runner.key}`
  const runnerDescription = runner.description
  const key = runner.key
  const title = useMemo(() => {
    let {name} = runner
    const {deprecation} = runner
    let deprecated = false

    if (deprecation?.type === 'external') {
      name += ' (external)'
    } else if (deprecation?.reason) {
      deprecated = true
      name += ' (deprecated)'
    }

    return {
      deprecated,
      name,
    }
  }, [runner])
  const handlerSelectBuildRunnersItemClick = useCallback(() => {
    onSelect()
    window.BS?.selectRunnerInFlattenMode &&
      window.BS?.selectRunnerInFlattenMode(runner.key, onLoadingComplete)
  }, [onLoadingComplete, onSelect, runner.key])

  return {
    title,
    dataTestId,
    runnerDescription,
    runnerIconUrl,
    handlerSelectBuildRunnersItemClick,
    key,
  }
}

export default useSelectBuildRunnersItem
